import {useEffect} from 'react'
import { useQueryState } from './useQuery'

export const usePostId = ()=> WP_OctaviusRocks_Admin.extensions.post_id

export const usePostPageviews = (postId)=>{
    const [result, query] = useQueryState("postPageviews_"+postId);
    useEffect(()=>{
        if(parseInt(postId)>0){
            query(WP_OctaviusRocks_Admin.extensions.oqlPageviews)
        }
    }, [postId])
    return result
}

export const usePostEvents = (postId)=>{
    const [result, query] = useQueryState("postEvents_"+postId);
    useEffect(()=>{
        if(parseInt(postId)>0){
            query(WP_OctaviusRocks_Admin.extensions.oqlEvents)
        }
    }, [postId])
    return result
}

export const usePostReferer = (postId)=>{
    const [result, query] = useQueryState("postReferers_"+postId)
    useEffect(()=>{
        if(parseInt(postId)>0){
            query(WP_OctaviusRocks_Admin.extensions.oqlTopReferer)
        }
    }, [postId])
    return result
}